<template>
    <!-- BEGIN: Content-->
    <div class="mt-0">
      <div class="flex">
        <div class="section_title"><span class="big-size weight-bold">{{ $store.state.loader_text }}&nbsp;&nbsp;</span>
          <span v-if="orgname !== null" style="font-size:11px !important;margin:auto !important;"> | {{ orgname.name }}</span>
          <div class="load"><v-progress-circular
            color="primary"
            indeterminate
            :size="18"
            :width="3"
            v-show="loader"
          ></v-progress-circular></div>
        </div>
        <div style="display:flex;align-items:center;justify-content:space-between;flex-direction:row">
          <v-btn
            color="primary"
            class="ma-1 white--text"
            @click="exportpdf"
            depressed
            :loading="loadingpdf"
            :disabled="disabledpdf"
          >
            Export Pdf
            <v-icon
              right
              dark
            >
              mdi-file-pdf-box
            </v-icon>
          </v-btn>

          <v-btn
            color="secondary"
            class="ma-1 white--text"
            @click="exportexcel"
            depressed
            :loading="loadingexcel"
            :disabled="disabledexel"
          >
            Export Excel
            <v-icon
              right
              dark
            >
              mdi-file-excel
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="invoiceDetail">
        <v-container fluid style="padding-top:0 !important;padding-bottom:0 !important">
          <v-row>
            <v-col cols="12" class="pb-0 mb-0 px-0">
              <div class="summaryAlert px-4">
               <!--  <div class="mb-2">
                  <span class="summaryTitle">Payment Summary <span v-if="orgname !== null">| {{ orgname.name }}</span></span>
                </div> -->
                <div class="summaryTotals mt-2">
                  <div class="totals">
                    <span class="font-normal">Cummulative Total</span>
                    <span class="font-medium">KES{{ 
                          allinvoices.reduce((acc, val) => acc + val.amount, 0) | currency(' ')
                        }}</span>
                  </div>
                  <div class="mx-5 arrow-right"></div>
                  <div class="totals">
                    <span class="font-normal">Cummulative Balance</span>
                    <span class="font-medium">KES{{ 

                          allinvoices.reduce( (acc, item) => 
                          {  
                            let total_amt = 0;
                            

                            total_amt = (
                              (item.amount) - 
                              ((item.payments.reduce((acc1, val) => acc1 + parseFloat(val.paidamount), 0))+item.creditnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)+(item.witholdingtax_sum_amount !== null ? parseFloat(item.witholdingtax_sum_amount) : 0))+
                              ((item.debitnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)
                              )+(item.payments.reduce((acc1, val) => acc1 + val.reversals.reduce((acc2, val2) => acc2 + parseFloat(val2.amount), 0), 0)
                              ))
                              ) > 0 ? (
                              (item.amount) - 
                              ((item.payments.reduce((acc1, val) => acc1 + parseFloat(val.paidamount), 0))+item.creditnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)+(item.witholdingtax_sum_amount !== null ? parseFloat(item.witholdingtax_sum_amount) : 0))+
                              ((item.debitnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)
                              )+(item.payments.reduce((acc1, val) => acc1 + val.reversals.reduce((acc2, val2) => acc2 + parseFloat(val2.amount), 0), 0)
                              ))
                              ) : 0;

                            return acc += total_amt;

                          }, 0).toFixed(2) | currency('')
                        }}</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row style="position:relative !important;z-index:1 !important;margin-bottom:0 !important">
            <v-col cols="12" class="py-0 px-0">
              <v-card class="card-shadow py-3">
                <v-card-title class="pt-0 mt-0" style="display:flex;align-items:center;justify-content:space-between">
                  <Search/>
                  <v-col md="2" cols="2" sm="2" class="px-1" style="padding-top:0 !important;padding-bottom:0 !important;display:flex;">
                    <v-text-field
                          v-model="searchfilter"
                          label="Search"
                          solo
                          hide-details="auto"
                        ></v-text-field>
                  </v-col>
                </v-card-title>
                <v-card-text class="px-0 py-0 cardtext1">
                  <v-virtual-scroll
                    :items="allinvoices"
                    :item-height="20"
                    renderless 
                    id="virtualscroll"
                    class="invoicedetails"
                   >
                    <template v-slot:default="{ item }">
                        <div class="tcell">{{ moment(item.date).format('MMM Do YYYY') }}</div>
                        <div class="tcell">
                          <RouterLink style="color:#F98525 !important;font-weight:600 !important;text-decoration:none !important" link
                              :to='{name:"showInvoice",params:{id:item.id}}'>{{ item.invoice_no }}</RouterLink>
                        </div>
                        <div class="tcell">
                          <span v-if="item.organisations.length > 0">{{ item.organisations[0].name }}</span>
                          <span v-else>Private</span>
                        </div>
                        <div class="tcell">
                          {{ item.status }}
                        </div>
                        <div class="tcell">
                          <span>
                              {{ item.amount | currency(' ') }}</span>
                        </div>
                        <div class="tcell">
                          <span>{{ 
                                (
                              (item.amount) - 
                              ((item.payments.reduce((acc1, val) => acc1 + parseFloat(val.paidamount), 0))+item.creditnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)+(item.witholdingtax_sum_amount !== null ? parseFloat(item.witholdingtax_sum_amount) : 0))+
                              ((item.debitnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)
                              )+(item.payments.reduce((acc1, val) => acc1 + val.reversals.reduce((acc2, val2) => acc2 + parseFloat(val2.amount), 0), 0)
                              ))
                              ).toFixed(2) > 0 ? (
                              (item.amount) - 
                              ((item.payments.reduce((acc1, val) => acc1 + parseFloat(val.paidamount), 0))+item.creditnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)+(item.witholdingtax_sum_amount !== null ? parseFloat(item.witholdingtax_sum_amount) : 0))+
                              ((item.debitnotes.reduce((acc1, val) => acc1 + parseFloat(val.amount), 0)
                              )+(item.payments.reduce((acc1, val) => acc1 + val.reversals.reduce((acc2, val2) => acc2 + parseFloat(val2.amount), 0), 0)
                              ))
                              ).toFixed(2) : 0 | currency('') }}</span>
                        </div>
                    </template>
                  </v-virtual-scroll>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
</template>
<style>
  .invoicedetails .v-virtual-scroll__item{
    width:100%;
    display: grid !important;
     grid-auto-columns: minmax(16.6667%, 16.6667%) !important;
     /*grid-template-columns: 6.11% 21.11% 12.11% 12.11% 14.11% 15.11% 11.11% 8.22%;*/
     grid-auto-flow: column !important;
     grid-gap: 0px;
  }
</style>
<script>
import axios from 'axios'
import {ability} from '@/services/ability'
import { format, parseISO } from 'date-fns'
import moment from 'moment'
import Search from '@/components/invoices/search'
import $ from 'jquery';

export default {
    name:"invoiceDetail",
    components: { Search },
    data(){
        return {
          daterange: {
            start: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
            end: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
          },
          searchfilter: '',
          search: '',
          dialog: false,
          searchdialog: false,
          loading: false,
          loadingpdf: false,
          loadingexcel: false,
          disabledpdf: false,
          disabledexel: false,
          fields: [
            {
              text: 'DATE',
              value: 'date',
            },
            { text: 'INVOICE#', value: 'invoiceno' },
            { text: 'ORGANISATION NAME', value: 'organisation' },
            { text: 'STATUS', value: 'status' },
            { text: 'AMOUNT(KES)', value: 'amount' },
            { text: 'BALANCE(KES)', value: 'balance' },
           ],
          item: {
            organisation_id: null,
            project_id: null
           },
 
        }
    },
    beforeMount() {
      if(!ability.can('view-reports', 'all')) {
        this.$router.push({ name: 'Dashboard' })
        return
      }
    },
    serverPrefetch () {
    },
    mounted(){

      this.$store.state.loader_text = "Invoice Summary"

      this.getInvoices()
      if(!this.minorganisations || this.minorganisations == 0) {
        this.getOrganisation()
      }

      let headertitle = `<div class="v-virtual-scroll__container"><div class="v-virtual-scroll__item" style="top: 0px;">`;
      this.fields.map(function(value, key) {
           headertitle +=`<div class="thead">${value.text}</div>`;
         });
      headertitle +=`</div></div>`;
      $('.v-virtual-scroll').prepend(headertitle)

    },
    computed: {
      loader() {
        return this.$store.state.tableloader
      },
      sinvoices () {
        return this.$store.state.invoicedetails.filter(item => {

          this.start = 0

          let invoice_no = "";
          let organisation = "";
          let amount = "";
          let date = "";
          if(item.organisations.length > 0) {
            organisation = item.organisations[0].name
          }
          if(item.invoice_no !== null) {
            invoice_no = item.invoice_no
          }
          if(item.amount !== null) {
            amount = item.amount
          }
          if(item.date !== null) {
            date = item.date
          }
          return organisation.toLowerCase().includes(this.searchfilter.toLowerCase()) || invoice_no.toLowerCase().includes(this.searchfilter.toLowerCase())
        })
      },
      allinvoices () {
        return this.sinvoices
      },
      orgname () {
        return this.$store.state.invoiceorganisation
      },
      invoicedata () {
        return this.$store.state.invoicedetailsdata
      }
    },
    methods:{
      showSearchDialog() {
        this.searchdialog = true
      },
      getOrganisation(){
        // this.$store.state.tableloader = true
        axios.get('/minorganisations').then(response=>{
            // this.$store.state.tableloader = false
            if(response.data.status == parseInt(200)) {
              this.$store.state.minorganisations = response.data.organisations
            }
        }).catch(error=>{
            // this.$store.state.tableloader = false
            console.log(error)
        })
      },
      exportexcel(){

        this.loadingexcel = true
        this.disabledexel = true

        const config = { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'arraybuffer' };
          let fd = new FormData();
          fd.append('organisation_id',this.invoicedata.organisation_id)
          fd.append('start',this.invoicedata.start)
          fd.append('end',this.invoicedata.end)

        axios.post('/invoice-details/export/excel', fd, config).then(response=>{
          this.loadingexcel = false
          this.disabledexel = false
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Invoice_details.xlsx');
         document.body.appendChild(fileLink);
         fileLink.click();
          
        })
        .catch(error => {
          this.loadingexcel = false
          this.disabledexel = false
          console.log("Unexpected error occured")
        })
      },
      exportpdf(){
        this.loadingpdf = true
        this.disabledpdf = true
        
        const config = { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob' };
          let fd = new FormData();
          fd.append('organisation_id',this.invoicedata.organisation_id)
          fd.append('start',this.invoicedata.start)
          fd.append('end',this.invoicedata.end)

        axios.post('/invoice-details/export/pdf', fd, config).then(response=>{
         this.loadingpdf = false
         this.disabledpdf = false
         var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
         var fileLink = document.createElement('a');
         fileLink.href = fileURL;
         fileLink.setAttribute('download', 'Invoice_details.pdf');
         document.body.appendChild(fileLink);
         fileLink.click();
          
        })
        .catch(error => {
          this.loadingpdf = false
          this.disabledpdf = false
          console.log("Unexpected error occured")
        })
      },
      getInvoices(){

          this.$store.state.tableloader = true

          axios.get('/organisations/allinvoice-details').then(response=>{
            this.$store.state.tableloader = false
            if(response.data.status == parseInt(200)) {
              this.$store.state.invoicedetails = response.data.invoices
            }
            
          })
          .catch(error => {
            this.$store.state.tableloader = false
            console.log(error)
          })

      },

    }
}
</script>